export const generateCompanySlug = (input: string, suffixLength = 6) => {
  const base = input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

  const normalized = base || 'company'
  const suffix = Math.random().toString(36).slice(2, 2 + Math.max(3, suffixLength))
  return `${normalized}-${suffix}`
}
